import { useTranslation } from 'react-i18next';
import { DlpScopeStatus } from 'utils/dlpConfigurationValidation';

export function ScopeStatusBadge({ status }: { status: DlpScopeStatus }) {
    const { t } = useTranslation();
    return <span className={`status-badge ${status}`}>{t(`dlpConfiguration.scopes.status.${status}`)}</span>;
}
